import {DataService} from '../data.service';
import {Router} from '@angular/router';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';


export class UserSearch {
  userId:number=-1;
  companyId:number=-1;
  searchItem:string="";
  _searchObj:UserSearch;
  static data:any[]=[];

  constructor(userid:number,companyid:number,search:string,private service:DataService,private router:Router){
    this.userId=userid;
    this.companyId=companyid;
    this.searchItem=search;

  }

  set Search(search:UserSearch){
    this._searchObj=search;
  }

  get Search(){
    return this._searchObj
  }

  getSearchModule() {
    const inputJson = {
      "CompanyId": this.Search.companyId,
      "Text": this.Search.searchItem,
      "UserId": this.Search.userId
    }
    // console.log(JSON.stringify(inputJson,undefined,2));
    this.service.GetSearchModule(inputJson)
      .subscribe(
        (result: any[]) => {
          if (result['Status'] == "Success") {
            this.Data = result['DashBoardData'];
            
            this.service.searchsub.next('change');
            this.router.navigate(['/search-results', this.Search.searchItem]);
          } else {
            this.service.alert(result['Message'], "error")
          }

        },
        (error) => {
          // console.log(error);
        }
      )
  }

  set Data(data){
    UserSearch.data=data;
  }

   get Data(){
    return UserSearch.data;
  }

  static getData(){
    return UserSearch.data
  }

  navigateToSearch(){
    this.router.navigate(['/search-results', this.Search.searchItem]);
  }





}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/models/user-search.ts